import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "@/lib/data";
import { Overline } from "@/components/Section";
import ApplyForm from "@/components/ApplyForm";
import SEOHead from "@/components/SEOHead";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <SEOHead
        title="Contact Hylas Companion | Truck Driver Recruiting | (708) 395-9565"
        description="Contact Hylas Companion trucking at (708) 395-9565 or contact@hylascompanion.com. Questions about CDL-A driver jobs, pay, positions, or equipment? Our recruiting team is ready to help."
        keywords="contact Hylas Companion, truck driver recruiting contact, CDL driver hotline, trucking recruiter phone"
        path="/contact"
      />
      <section className="pt-32 md:pt-40 pb-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 items-start">
          <div>
            <Overline>Contact</Overline>
            <h1 className="font-head text-4xl md:text-6xl font-bold uppercase tracking-[0.15em] mt-5 leading-tight">
              Let's Talk Freight
            </h1>
            <p className="mt-6 text-lg text-foreground/70 max-w-md leading-relaxed">
              Questions about pay, positions, or equipment? Reach out — or just drop your info and we'll call you.
            </p>

            <div className="mt-10 space-y-6">
              <a href={`tel:${BRAND.phone}`} data-testid="contact-phone" className="flex items-center gap-5 group">
                <span className="w-12 h-12 bg-[#0A0A0A] flex items-center justify-center group-hover:bg-primary transition-colors">
                  <Phone className="w-5 h-5 text-primary group-hover:text-black" />
                </span>
                <div>
                  <p className="font-head text-xs uppercase tracking-[0.25em] text-muted-foreground">Call Us</p>
                  <p className="text-lg text-[#0A0A0A]">{BRAND.phone}</p>
                </div>
              </a>
              <a href={`mailto:${BRAND.email}`} data-testid="contact-email" className="flex items-center gap-5 group">
                <span className="w-12 h-12 bg-[#0A0A0A] flex items-center justify-center group-hover:bg-primary transition-colors">
                  <Mail className="w-5 h-5 text-primary group-hover:text-black" />
                </span>
                <div>
                  <p className="font-head text-xs uppercase tracking-[0.25em] text-muted-foreground">Email</p>
                  <p className="text-lg text-[#0A0A0A]">{BRAND.email}</p>
                </div>
              </a>
              <div className="flex items-center gap-5">
                <span className="w-12 h-12 bg-[#0A0A0A] flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-primary" />
                </span>
                <div>
                  <p className="font-head text-xs uppercase tracking-[0.25em] text-muted-foreground">Coverage</p>
                  <p className="text-lg text-[#0A0A0A]">All 48 States · Coast to Coast</p>
                </div>
              </div>
            </div>
          </div>

          <ApplyForm />
        </div>
      </section>
    </div>
  );
}
